/* Japan Card Collect — panier Shopify réel + mini-panier coulissant (global).
   - Compteur header depuis /cart.js
   - Icône panier → ouvre le tiroir (plus de navigation vers /cart)
   - Tous les .ccard__add (rails, grilles) : add.js puis ouverture du tiroir
   - window.JCC_CART.refresh(cart, open) : appelé par la fiche produit après ajout
   - Steppers + suppression dans le tiroir via /cart/change.js */
(function () {
  "use strict";
  const I18N = window.I18N || { fr: {}, en: {} };
  const $ = (id) => document.getElementById(id);
  const lang = () => ((document.documentElement.lang || "fr") === "en" ? "en" : "fr");
  const t = (k) => (I18N[lang()] && I18N[lang()][k]) || (I18N.fr && I18N.fr[k]) || "";
/* Devise : NE PAS coder « € » en dur. Avec Shopify Markets et les devises locales, les prix
   Liquid arrivent déjà CONVERTIS dans la devise du visiteur : un client polonais recevait 859
   (zloty) affichés « 859,00 € », soit 4,4x le vrai prix de la carte. On formate donc avec la
   devise active, en gardant les conventions typographiques de la langue. */
  const DEVISE = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  const fmtMoney = (n) => { try { return new Intl.NumberFormat(lang() === "en" ? "en-GB" : "fr-FR",
      { style: "currency", currency: DEVISE }).format(n); }
    catch (e) { return (lang() === "en" ? "" : "") + n.toFixed(2) + " " + DEVISE; } };
  const money = (c) => fmtMoney((c / 100));
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]));
  const FREE = 20000; /* livraison offerte ≥ 200 € (cents) */
  const eur = (p) => (lang() === "en" ? "€" + (+p).toFixed(2) : (+p).toFixed(2).replace(".", ",") + " €");
  const base = (window.JCC && window.JCC.base) || "/cdn/shop/t/2/assets/";
  let _upsell = null; /* pool AR abordables (4–25 €), chargé 1×, exclut le panier */

  function setCount(n) {
    const c = document.querySelector(".cart__count");
    if (!c) return;
    c.textContent = n;
    c.hidden = !n;               /* masqué quand le panier est vide */
    if (n) c.animate([{ transform: "scale(1)" }, { transform: "scale(1.5)" }, { transform: "scale(1)" }],
      { duration: 320, easing: "ease-out" });
  }

  /* ================= Tiroir ================= */
  const drawer = $("miniCart");
  const backdrop = $("mcBackdrop");
  let busy = false;

  function open() {
    if (!drawer) return;
    drawer.hidden = false; backdrop.hidden = false;
    const sc = $("mcScroll"); if (sc) sc.scrollTop = 0;
    requestAnimationFrame(() => { drawer.classList.add("is-open"); backdrop.classList.add("is-open"); });
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove("is-open"); backdrop.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(() => { if (!drawer.classList.contains("is-open")) { drawer.hidden = true; backdrop.hidden = true; } }, 300);
  }

  function itemRow(it) {
    const name = (it.product_title || "").split(" — ")[0];
    const ref = (it.product_title || "").split(" — ")[1] || "";
    const variant = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
    const img = it.image ? it.image.replace(/(\.\w+)(\?|$)/, "$1?width=160$2").replace("?width=160?", "?width=160&") : "";
    return '<div class="mc-item" data-key="' + esc(it.key) + '">' +
      '<a class="mc-item__media" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" />' : "") + "</a>" +
      '<div class="mc-item__info">' +
        '<a class="mc-item__name" href="' + esc(it.url) + '">' + esc(name) + "</a>" +
        '<span class="mc-item__meta">' + esc(ref) + (variant ? ' · <span class="cond-ico cond-ico--' + variant.toLowerCase() + '">' + esc(variant) + "</span>" : "") + "</span>" +
        '<div class="mc-item__ctl">' +
          '<div class="pp-qty pp-qty--sm"><button type="button" data-mc="less" aria-label="Moins">−</button>' +
          '<input type="number" min="0" value="' + it.quantity + '" inputmode="numeric" aria-label="Quantité" />' +
          '<button type="button" data-mc="more" aria-label="Plus">+</button></div>' +
          '<button type="button" class="mc-item__rm" data-mc="rm">' + t("cart_remove") + "</button>" +
        "</div>" +
      "</div>" +
      '<b class="mc-item__price">' + money(it.final_line_price) + "</b></div>";
  }

  function render(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    const cnt = $("mcCount");
    if (cnt) cnt.textContent = cart.item_count;
    const body = $("mcBody"), ship = $("mcShip"), foot = $("mcFoot");
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="mc-empty"><p class="mc-empty__ico" aria-hidden="true">🃏</p>' +
        "<p>" + t("cart_empty") + "</p>" +
        '<a class="btn btn--primary" href="/collections/nouveautes">' + t("cart_empty_new") + "</a></div>";
      ship.hidden = true; foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(itemRow).join("");
    /* barre livraison offerte */
    ship.hidden = false;
    const remaining = FREE - cart.total_price;
    if (remaining <= 0) {
      ship.classList.add("is-free");
      $("mcShipTxt").innerHTML = "🎉 <b>" + t("cart_free_ok") + "</b> " + t("cart_free_ok2");
    } else {
      ship.classList.remove("is-free");
      $("mcShipTxt").innerHTML = "🚚 " + t("cart_free_more_1") + " <b>" + money(remaining) + "</b> " + t("cart_free_more_2");
    }
    $("mcBar").style.width = Math.min(100, cart.total_price / FREE * 100) + "%";
    /* pied */
    foot.hidden = false;
    $("mcSubtotal").textContent = money(cart.total_price);
    const trust = $("mcTrust"); if (trust) trust.hidden = false;
    /* upsell : cartes AR abordables absentes du panier */
    const inCart = new Set(cart.items.map((it) => it.handle));
    renderUpsell($("mcUpsellRail"), $("mcUpsell"), inCart);
  }

  function upsellCard(c) {
    const name = (lang() === "en" ? c.en : c.fr) || c.fr;
    const handle = c.code.toLowerCase() + "-" + c.n;
    return '<div class="us-card">' +
      '<a class="us-card__media" href="/products/' + handle + '"><img src="' + base + esc(c.img) + '" alt="' + esc(name) + '" loading="lazy" /></a>' +
      '<span class="us-card__name">' + esc(name) + '</span>' +
      '<div class="us-card__foot"><span class="us-card__price">' + eur(c.price) + '</span>' +
      '<button class="us-card__add" type="button" data-us="' + handle + '" aria-label="Ajouter">+</button></div></div>';
  }
  function renderUpsell(rail, wrap, exclude) {
    if (!rail || !wrap) return;
    const paint = () => {
      const list = (_upsell || []).filter((c) => !exclude.has(c.code.toLowerCase() + "-" + c.n)).slice(0, 10);
      if (!list.length) { wrap.hidden = true; return; }
      rail.innerHTML = list.map(upsellCard).join("");
      wrap.hidden = false;
    };
    if (_upsell) return paint();
    fetch(window.JCC.data.ar).then((r) => r.json()).then((d) => {
      _upsell = (d.cards || []).filter((c) => c.n && c.img && c.price);
      paint();
    }).catch(() => {});
  }

  function refresh(cart, doOpen) {
    if (cart) render(cart);
    else fetch("/cart.js").then((r) => r.json()).then(render).catch(() => {});
    if (doOpen) open();
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then((r) => r.json()).then((cart) => {
      busy = false;
      /* stock dépassé → Shopify renvoie un objet d'erreur (pas de .items) :
         on resynchronise sur l'état réel du panier (quantité plafonnée). */
      if (cart && cart.items) render(cart);
      else fetch("/cart.js").then((r) => r.json()).then(render).catch(() => {});
    }).catch(() => {
      busy = false;
      fetch("/cart.js").then((r) => r.json()).then(render).catch(() => {});
    });
  }

  /* Ajout partagé (rails/grilles) : résout la variante puis add.js → tiroir */
  function addByHandle(handle, btn, openDrawer) {
    return fetch("/products/" + handle + ".js")
      .then((r) => { if (!r.ok) throw 0; return r.json(); })
      .then((p) => {
        const v = (p.variants || []).find((x) => x.available) || p.variants[0];
        if (!v) throw 0;
        return fetch("/cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: v.id, quantity: 1 }),
        });
      })
      .then((r) => { if (!r.ok) throw 0; return fetch("/cart.js").then((x) => x.json()); })
      .then((cart) => { if (openDrawer !== false) refresh(cart, true); else render(cart); return cart; });
  }

  /* ================= Init ================= */
  fetch("/cart.js").then((r) => r.json()).then((c) => {
    setCount(c.item_count);
    render(c);
  }).catch(() => {});

  const cartBtn = document.querySelector(".header__actions .cart");
  if (cartBtn) cartBtn.addEventListener("click", (e) => { e.preventDefault(); refresh(null, true); });

  if (drawer) {
    $("mcClose").addEventListener("click", close);
    backdrop.addEventListener("click", close);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer.classList.contains("is-open")) close(); });
    $("mcBody").addEventListener("click", (e) => {
      const row = e.target.closest(".mc-item"); if (!row) return;
      const act = e.target.closest("[data-mc]"); if (!act) return;
      const key = row.dataset.key, input = row.querySelector("input");
      if (act.dataset.mc === "less") change(key, Math.max(0, parseInt(input.value, 10) - 1));
      else if (act.dataset.mc === "more") change(key, parseInt(input.value, 10) + 1);
      else if (act.dataset.mc === "rm") change(key, 0);
    });
    $("mcBody").addEventListener("change", (e) => {
      if (e.target.matches(".mc-item input")) {
        const row = e.target.closest(".mc-item");
        change(row.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });
  }

  function handleFrom(el) {
    const holder = el.closest("[data-handle]");
    if (holder && holder.dataset.handle) return holder.dataset.handle;
    const nav = el.closest("[data-href]");
    const href = (nav && nav.dataset.href) || "";
    const m = href.match(/\/products\/([a-z0-9-]+)/);
    return m ? m[1] : null;
  }
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".ccard__add");
    if (!btn) return;
    e.stopPropagation(); e.preventDefault();
    if (btn.disabled || btn.dataset.busy) return;
    const handle = handleFrom(btn);
    if (!handle) return;
    btn.dataset.busy = "1";
    const old = btn.textContent;
    addByHandle(handle, btn, true)
      .then(() => {
        btn.classList.add("is-added"); btn.textContent = "✓";
        setTimeout(() => { btn.classList.remove("is-added"); btn.textContent = t("set_add") || old; delete btn.dataset.busy; }, 1100);
      })
      .catch(() => { delete btn.dataset.busy; location.href = "/products/" + handle; });
  }, true);

  /* Bouton "+" upsell : ajoute la carte puis rafraîchit (tiroir) ou recharge (page panier) */
  document.addEventListener("click", (e) => {
    const b = e.target.closest(".us-card__add");
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.dataset.busy) return;
    const onCartPage = !!document.querySelector(".cartp");
    b.dataset.busy = "1"; b.textContent = "✓"; b.classList.add("is-added");
    addByHandle(b.dataset.us, b, !onCartPage)
      .then(() => { if (onCartPage) location.reload(); })
      .catch(() => {})
      .then(() => { delete b.dataset.busy; setTimeout(() => { b.textContent = "+"; b.classList.remove("is-added"); }, 900); });
  });

  /* Page panier : rendre l'upsell dans son conteneur dédié */
  (function () {
    const rail = $("cartpUpsellRail"), wrap = $("cartpUpsell");
    if (!rail || !wrap) return;
    fetch("/cart.js").then((r) => r.json()).then((cart) => {
      renderUpsell(rail, wrap, new Set(cart.items.map((it) => it.handle)));
    }).catch(() => {});
  })();

  /* Flèches de défilement du carrousel upsell (PC) */
  (function () {
    document.querySelectorAll(".us-arrow").forEach((b) => {
      b.addEventListener("click", () => {
        const rail = $(b.dataset.rail);
        if (!rail) return;
        const card = rail.querySelector(".us-card");
        const step = card ? card.getBoundingClientRect().width + 12 : 160;
        rail.scrollBy({ left: (b.classList.contains("us-arrow--prev") ? -1 : 1) * step * 2, behavior: "smooth" });
      });
    });
    /* masquer les flèches si tout tient / aux extrémités */
    document.querySelectorAll(".us-rail").forEach((rail) => {
      const wrap = rail.closest(".us-wrap");
      if (!wrap) return;
      const sync = () => {
        const overflow = rail.scrollWidth > rail.clientWidth + 4;
        wrap.classList.toggle("has-overflow", overflow);
        wrap.classList.toggle("at-start", rail.scrollLeft <= 2);
        wrap.classList.toggle("at-end", rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2);
      };
      rail.addEventListener("scroll", sync, { passive: true });
      addEventListener("resize", sync);
      new MutationObserver(sync).observe(rail, { childList: true });
      sync();
    });
  })();

  window.JCC_CART = { refresh: refresh, open: open, close: close };
})();
